import React from 'react';
import { Monitor, Sun, Moon } from 'lucide-react';
import SegmentedControl from './SegmentedControl';
import { useTheme } from '../../lib/theme';

const OPTIONS = [
  { value: 'system', label: 'Auto', icon: Monitor, title: 'Match this device' },
  { value: 'light', label: 'Light', icon: Sun },
  { value: 'dark', label: 'Dark', icon: Moon },
];

// Appearance picker: Auto follows the operating system.
function ThemeControl({ className = '', size = 'md', fullWidth = false }) {
  const [theme, setTheme] = useTheme();
  return (
    <SegmentedControl
      options={OPTIONS}
      value={theme}
      onChange={setTheme}
      label="Appearance"
      size={size}
      fullWidth={fullWidth}
      className={className}
    />
  );
}

export default ThemeControl;
